import styled from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';

const TextAreaWrapper = styled.textarea`
  /* border: none; */
  border: 1px solid ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.fonts.sizeBase};
  padding: 10px;
  outline: none;
  font-family: ${props => props.theme.fonts.fontfaceBeta};
  line-height: 1em;
  width: 100%;
  min-height: 40px;
  height: 120px;
  -webkit-appearance: none;
  border-radius: 0;
  resize: vertical;
`;

export default class TextArea extends React.Component {
  hasFocus = false;

  componentWillReceiveProps(nextProps) {
    this.textInput.value = nextProps.textValue;
  }

  componentWillUpdate() {
    if (this.hasFocus) {
      return false;
    }
    return true;
  }

  onBlur() {
    const { onBlur } = this.props;
    if (onBlur) onBlur();
    this.hasFocus = false;
  }

  onFocus() {
    const { onFocus } = this.props;
    if (onFocus) onFocus();
    this.hasFocus = true;
  }

  render() {
    const { onChange } = this.props;

    return (
      <TextAreaWrapper
        innerRef={input => {
          this.textInput = input;
        }}
        onChange={e => onChange(e.target.value)}
        onBlur={() => this.onBlur()}
        onFocus={() => this.onFocus()}
        row="3"
      />
    );
  }
}

TextArea.propTypes = {
  textValue: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/TextArea/TextArea.js